import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Context from './Context/Context';
import MyAuth0Provider from './contexts/MyAuth0Provider';
import WebSocketProvider from './Context/websocket';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Context>
  <React.StrictMode>
    <MyAuth0Provider>
    <BrowserRouter>
    <WebSocketProvider>
    <App />
    </WebSocketProvider>
    </BrowserRouter>
    </MyAuth0Provider>
  </React.StrictMode>
  </Context>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
